export default "__VITE_ASSET__Z4nj6hrE__"